'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _DatePickerWrapper = require('./DatePickerWrapper');

var _DatePickerWrapper2 = _interopRequireDefault(_DatePickerWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomDatePicker = function (_Component) {
  _inherits(CustomDatePicker, _Component);

  function CustomDatePicker() {
    _classCallCheck(this, CustomDatePicker);

    return _possibleConstructorReturn(this, (CustomDatePicker.__proto__ || Object.getPrototypeOf(CustomDatePicker)).apply(this, arguments));
  }

  _createClass(CustomDatePicker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          showYearDropdown = _props.showYearDropdown,
          value = _props.value,
          onChange = _props.onChange,
          timeIntervals = _props.timeIntervals,
          customInput = _props.customInput,
          other = _objectWithoutProperties(_props, ['disabled', 'showYearDropdown', 'value', 'onChange', 'timeIntervals', 'customInput']);

      return _react2.default.createElement(
        _DatePickerWrapper2.default,
        null,
        _react2.default.createElement(_reactDatepicker2.default, _extends({
          dateFormat: 'DD.MM.YYYY',
          timeIntervals: timeIntervals,
          selected: value,
          onChange: onChange,
          disabled: disabled,
          isClearable: !disabled,
          showYearDropdown: showYearDropdown,
          placeholderText: 'DD.MM.YYYY',
          timeCaption: '\u010Cas',
          customInput: customInput
        }, other))
      );
    }
  }]);

  return CustomDatePicker;
}(_react.Component);

exports.default = CustomDatePicker;


CustomDatePicker.defaultProps = {
  disabled: false,
  showYearDropdown: true,
  value: null,
  timeIntervals: 5,
  customInput: _react2.default.createElement(_DatePickerWrapper.Input, null)
};

CustomDatePicker.propTypes = {
  disabled: _propTypes2.default.bool,
  value: _propTypes2.default.objectOf(_moment2.default),
  onChange: _propTypes2.default.func.isRequired,
  showYearDropdown: _propTypes2.default.bool,
  timeIntervals: _propTypes2.default.number,
  customInput: _propTypes2.default.node
};
CustomDatePicker.__docgenInfo = [{
  'description': '',
  'displayName': 'CustomDatePicker',
  'methods': [],
  'props': {
    'disabled': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'value': {
      'type': {
        'name': 'objectOf',
        'value': {
          'name': 'custom',
          'raw': 'moment'
        }
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'showYearDropdown': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'true',
        'computed': false
      }
    },
    'timeIntervals': {
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '5',
        'computed': false
      }
    },
    'customInput': {
      'type': {
        'name': 'node'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '<Input />',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/DatePickers/DatePicker.js'] = {
    name: 'CustomDatePicker',
    docgenInfo: CustomDatePicker.__docgenInfo,
    path: 'src/DatePickers/DatePicker.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/DatePickers/DatePicker.js
// module id = 168
// module chunks = 1